import Vue from "vue";
import VueRouter from "vue-router";
import mainRouter from "./main/router";
import loginRouter from "./login/router";

import calRouter from "./cal/router";
import corpRouter from "./corp/router";
import obituaryRouter from "./obituary/router";

import mortuaryRouter from "./mortuary/router";
import tabletRouter from "./tablet/router";
import movieRouter from "./movie/router";
import paybackRouter from "./payback/router";
import skinBannerRouter from "./skinBanner/router";

import defaultRouter from "./router";

import store from "@/store";

Vue.use(VueRouter);

const routes = [
  ...defaultRouter,
  ...mainRouter,
  ...loginRouter,
  ...obituaryRouter,

  ...mortuaryRouter,
  ...tabletRouter,

  ...movieRouter,
  ...paybackRouter,
  ...calRouter,
  ...corpRouter,
  ...skinBannerRouter
];

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {
  //여기서 모든 라우팅이 대기 상태가 됨
  /**
   * to: 이동할 url 정보가 담긴 라우터 객체
   * from: 현재 url 정보가 담긴 라우터 객체
   * next: to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
   * next() 가 호출되기 전까지 화면 전환되지 않음
   */

  if (to.path === "/login" || to.name === "LoginDo") {
    return next();
  }

  let access_token = localStorage.getItem("access_token");
  let access_type = localStorage.getItem("access_type");

  if (
    to.fullPath.indexOf("/director") !== -1 &&
    access_token &&
    access_type === "director"
  ) {
    setTimeout(() => {
      store.dispatch("DIRECTOR_DETAIL");
    }, 1000);
  }
  if (
    to.fullPath.indexOf(
      "/funeral" && access_token && access_type === "funeral"
    ) !== -1
  ) {
    setTimeout(() => {
      store.dispatch("FUNERAL_DETAIL");
    }, 1000);
  }

  if (
    to.fullPath.indexOf("/corp") !== -1 &&
    access_token &&
    access_type === "corp"
  ) {
    setTimeout(() => {
      store.dispatch("CORP_DETAIL");
    }, 1000);
  }

  return next();
});

export default router;
